module.exports = __webpack_public_path__ + "img/上方山国家森林公园.8d94f904.png";